import { useMemo } from "react"; // 1. Import useMemo
import { ApiSystem } from "../state/types";
import { fetchAuthSession } from "aws-amplify/auth";
import apiClient from "./apiClient";

// This remains outside and stable
export async function getAuthHeaders() {
  const session = await fetchAuthSession({ forceRefresh: true });

  const idJwt = session.tokens?.idToken?.toString();
  if (!idJwt) throw new Error("No idToken available");

  return {
    Authorization: idJwt,
    "Content-Type": "application/json",
  };
}

export const useSystemsApi = () => {
  // 2. Wrap the return in useMemo
  return useMemo(() => {
    return {
      getSystemsApi: async () => {
        const { data } = await apiClient.get(`/system`);
        return data.systems as ApiSystem[];
      },

      createSystemApi: async (system: ApiSystem) => {
        await apiClient.post<ApiSystem>(`/system/create`, system);
        return system;
      },

      updateSystemApi: async (system: ApiSystem) => {
        await apiClient.put<ApiSystem>(`/system`, { system });
        return system;
      },

      deleteSystemApi: async (systemCode: string) => {
        await apiClient.delete(`/system/${systemCode}`);
      },
    };
  }, []); // 3. Empty dependencies ensure these function references stay the same
};